import { useMemo } from 'react'
import { ButtonType, ButtonState } from '../types'

export const useButtonClassName = (type?: ButtonType, state?: ButtonState) => {
  return useMemo(() => {
    if (!type) return ''
    switch (type) {
      case 'error':
        return 'errorButton'
      case 'lock':
        return 'lockButton'
      case 'verified':
        return 'verifiedButton'
      case 'eye':
        return state === 'default' ? 'eyeButtonDefault' : 'eyeButtonSwitched'
      default:
        return ''
    }
  }, [type, state])
}
